import React, { useMemo } from 'react';

import { getAvailablePages, SiteConfigManager } from '@atlas/core';
import { ContactSupportTeam } from '@atlas/ui';

import { availableGeneralRoutes } from '../MainRouter/constants';

const ContactSupportTeamContainer = ({ children }) => {
  const routes = useMemo(
    () => getAvailablePages(availableGeneralRoutes, SiteConfigManager.getExtraConfig('components')),
    [],
  );

  if (!routes.length) {
    return <ContactSupportTeam />;
  }

  return children;
};

export default ContactSupportTeamContainer;
